(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-popup"] && !Shopify.designMode) return;
  try {
    
  class ContentPopup extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.storageKey = 'content-popup-closed-' + (this.dataset.sectionId || '');
      this.media = this.querySelector('.content-popup__media');
      this.video = this.querySelector('.content-popup__video');
      this.closeBtn = this.querySelector('.content-popup__close');
      this.reopenBtn = this.querySelector('.content-popup__reopen');
      this.muteBtn = this.querySelector('.content-popup__mute');
      this.restartBtn = this.querySelector('.content-popup__restart');

      if (!this.media || !this.video) return;

      let dismissed = false;
      try {
        dismissed = sessionStorage.getItem(this.storageKey) === 'true';
      } catch (e) {}

      if (dismissed) {
        this.classList.add('content-popup--closed');
      }

      this.initVideo();

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (event) => {
          event.stopPropagation();
          this.closePopup();
        });
      }

      if (this.reopenBtn) {
        this.reopenBtn.addEventListener('click', () => {
          this.openPopup();
        });
      }
    }

    closePopup() {
      this.classList.add('content-popup--closed');
      this.video.pause();
      try {
        sessionStorage.setItem(this.storageKey, 'true');
      } catch (e) {}
    }

    openPopup() {
      this.classList.remove('content-popup--closed');
      this.video.play().catch(() => {});
      try {
        sessionStorage.removeItem(this.storageKey);
      } catch (e) {}
    }

    initVideo() {
      this.video.removeAttribute('width');
      this.video.removeAttribute('height');
      this.video.style.width = '100%';
      this.video.style.height = '100%';
      this.video.style.objectFit = 'cover';
      this.video.muted = true;
      this.media.classList.remove('content-popup__media--unmuted');

      this.media.addEventListener('click', (event) => {
        if (event.target.closest('.content-popup__close, .content-popup__mute, .content-popup__restart')) {
          return;
        }

        if (this.video.paused) {
          this.video.play().catch(() => {});
        } else {
          this.video.pause();
        }
      });

      if (this.muteBtn) {
        this.muteBtn.addEventListener('click', (event) => {
          event.stopPropagation();
          this.video.muted = !this.video.muted;
          this.media.classList.toggle('content-popup__media--unmuted', !this.video.muted);
        });
      }

      if (this.restartBtn) {
        this.restartBtn.addEventListener('click', (event) => {
          event.stopPropagation();
          this.video.currentTime = 0;
          this.video.play().catch(() => {});
        });
      }
    }
  }

  if (!customElements.get('content-popup')) {
    customElements.define('content-popup', ContentPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
